const translations = {
  generateTemplate: 'Generar plantilla de importación',
  exportOf: 'Exportación de {{name}}',
  generate: 'Generar',
  all: 'Todas',
  customize: 'Personalizar',
  exportPdf: 'Exportar PDF',
  exportExcel: 'Exportar Excel',
  columns: 'Columnas',
  pdfInfo:
    'En formato PDF, se enviará por correo electrónico un resumen de cada actividad, listo para su visualización e impresión.',
  creationDate: 'Fecha de creación',
  schedulingDate: 'Fecha de programación',
  period: 'Periodo',
  includeReplies: 'Incluir respuestas',
  includeRepliesTooltip: 'Al marcar esta opción, se incluirán todas las columnas de la actividad.',
  checklist: 'Cuestionario',
  formatBlockQuestions: 'Formatear preguntas de bloque',
  formatBlockQuestionsTooltip:
    'Cada línea de respuesta será una línea del archivo exportado \n con los demás valores repetidos.',
  type: 'Tipo',
  name: 'Nombre',
  email: 'Email',
  levels: 'Niveles',
  place: 'Lugar',
  number: 'Número',
  placeOrPerson: 'Lugar/Persona',
  userField: 'Usuario',
  startDate: 'Fecha inicial',
  endDate: 'Fecha final',
  replies: 'Respuestas',
  exportingSelected: 'Exportando {{count}} actividad seleccionada',
  exportingSelected_plural: 'Exportando {{count}} actividades seleccionadas',
  exportHistory: 'Historial de Exportación',
  of: 'de',
  date: 'Fecha',
  entity: 'Entidad',
  user: 'Usuario',
  download: 'Descargar',
  error: 'Error'
}

export default translations
